module.exports = "---\n{{{files.0.content.yamlProperties}}}\n---\n\n{{{files.0.content.html}}}\n"


//////////////////
// WEBPACK FOOTER
// ./src/data/templates/jekyllSiteTemplate.html
// module id = 2204
// module chunks = 1